"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CalendarOptionButton = _interopRequireDefault(require("./CalendarOptionButton"));

var _calendarLink = require("calendar-link");

var _calendarLinkData = require("../../../../constants/calendarLinkData");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var escapeComma = function escapeComma(text) {
  if (!text || typeof text !== 'string') return text;
  return text.replace(/\,/g, '\\,'); // eslint-disable-line no-useless-escape
};

var IcalButton = function IcalButton(_ref) {
  var event = _ref.event,
      _ref$onAddToCalendarC = _ref.onAddToCalendarClick,
      onAddToCalendarClick = _ref$onAddToCalendarC === void 0 ? function () {} : _ref$onAddToCalendarC,
      _ref$onAddToCalendarM = _ref.onAddToCalendarMount,
      onAddToCalendarMount = _ref$onAddToCalendarM === void 0 ? function () {} : _ref$onAddToCalendarM;
  var calendarType = 'ical';
  var link = (0, _calendarLink.ics)(_objectSpread({}, event, {
    description: escapeComma(event.description),
    location: escapeComma(event.location)
  }));
  return /*#__PURE__*/_react["default"].createElement(_CalendarOptionButton["default"], {
    linkProps: {
      href: link,
      onClick: function onClick() {
        return onAddToCalendarClick({
          calendarType: calendarType
        });
      }
    },
    onMount: function onMount() {
      return onAddToCalendarMount({
        calendarType: calendarType
      });
    },
    icon: _calendarLinkData.iCalData.icon,
    calendarName: _calendarLinkData.iCalData.name
  });
};

IcalButton.propTypes = {
  event: _propTypes["default"].object.isRequired,
  onAddToCalendarClick: _propTypes["default"].func,
  onAddToCalendarMount: _propTypes["default"].func
};
var _default = IcalButton;
exports["default"] = _default;